import { useEffect } from "react";
import io from "socket.io-client";
import { BASE_URL } from "@/constants/url";
import UploadOfferForm from "@/pages/manage-offers/UploadOfferForm/UploadOfferForm";
const socket = io(BASE_URL, {});

const UploadOffer = () => {
  useEffect(() => {
    socket.connect();
    socket.on("connect", () => {
      console.log("client is connected :", socket.id); // x8WIv7-mJelg7on_ALbx
    });

    socket.on("disconnect", () => {
      console.log("client is disconnected :", socket.connected); // false
    });

    socket.on("welcome", (data) => {
      console.log(data.message);
    });

    socket.on("disconnect", () => {
      console.log("disconncted from server");
      socket.connect();
    });

    // Cleanup: Disconnect socket when the component unmounts
    return () => {
      socket.disconnect();
    };
  }, []);

  return <UploadOfferForm socket={socket} />;
};
export default UploadOffer;
